import React from 'react'
import { Card, Title, LineChart } from '@tremor/react'

const data = [
  {
    name: 'Enero',
    Ventas: 2890,
  },
  {
    name: 'Febrero',
    Ventas: 1890,
  },
  {
    name: 'Marzo',
    Ventas: 3890,
  },
  {
    name: 'Abril',
    Ventas: 3490,
  },
  {
    name: 'Mayo',
    Ventas: 2490,
  },
  {
    name: 'Junio',
    Ventas: 2890,
  },
]

export const TremorChart: React.FC = () => {
  return (
    <div className="w-full h-[400px] p-4">
      <Card className="w-full h-full">
        <Title>Ventas por Mes</Title>
        <div className="h-[300px] mt-4">
          <LineChart
            data={data}
            index="name"
            categories={['Ventas']}
            colors={['blue']}
            valueFormatter={(number: number) =>
              Intl.NumberFormat('es-AR')
                .format(number)
                .toString()
            }
            yAxisWidth={48}
            showLegend
            showAnimation
            showGridLines
            showTooltip
          />
        </div>
      </Card>
    </div>
  )
}
